import React from 'react';
import {Grid } from '@material-ui/core'
import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar style={{width:"100%",padding:"10px 0"}}>
      
          <Grid  container justify="center" alignItems="center">
          <NavItem >
          2021 Everestwalk Group pvt. ltd.
          </NavItem>
          </Grid>
        
      </Nav>
    </Navbar>
  );
};
export default Footer;
